import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import background from "modules/auth/assets/background.png";
import backgroundMobile from "modules/auth/assets/background-mobile.png";

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    backgroundColor: "#fff8f1",
    backgroundImage: `url(${background})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    overflowY: "auto",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      backgroundImage: `url(${backgroundMobile})`,
    },
  },
  infoBox: {
    width: "100%",
    height: "100%",
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
    },
  },
  attendeeInfoBox: {
    color: theme.palette.white,
    alignItems: "flex-end",
  },
  hostInfoBox: {
    color: theme.palette.white,
    backgroundColor: theme.palette.blue.dark,
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(15),
    },
  },
  disclaimer: {
    opacity: 0.75,
  },
  infoBoxListItemText: {
    fontSize: theme.typography.h4.fontSize,
  },
  attendEventsButton: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  startFreeTrialButton: {
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
